export default "__VITE_ASSET__CXaKHH1Y__";